export const packageModuleMap = [
  ['MODULE_1', 'Module 1  Kickoff+Activity List Guidance'],
  ['MODULE_2', 'Module 2  PS Brainstorming'],
  ['MODULE_3', 'Module 3  Supplemental Easays Brainstorming'],
  ['MODULE_6', 'Module 6  Comprehensive Support (CS) Hours'],
  ['MODULE_7', 'FAO Mock Review'],
  ['LONG_TERM', 'Long-term Planning Module']
]
